<template>
    <div v-if="hasMultipleOffices" class="office-chooser center-text full-width">
    <v-menu offset-y max-height="400" nudge-bottom="0" class="full-width" v-model="menuVisible">
        <template v-slot:activator="{ on }">
        <div v-on="on" class="office-chooser-button div-button rounded center-text full-width" :class="buttonClass" :style="buttonStyle">
            <div><v-icon style="color:inherit;padding-top:3px">mdi-account-supervisor-circle</v-icon></div>
            <div style="flex-grow:1;padding:3px 3px 3px 6px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;">{{currentOffice.name}}</div>
            <div style="padding:5px 3px 3px 6px;">{{activeCount}}</div>
            <v-icon style="color:inherit;padding-top:2px">arrow_drop_down</v-icon>
        </div>
        </template>
        <div v-if="debugInfinite"></div>
        <v-list>
            <v-list-item @click="$router.push('/preferences')">
                <v-list-item-action>
                        <v-icon>mdi-settings</v-icon>
                </v-list-item-action>
                <v-list-item-title>Preferences</v-list-item-title>
            </v-list-item>
            <v-divider />
            <v-list-item v-for="(office) in offices" @click="switchToOffice(office)" :key="office.meta.key" :class="{'blue-hilight': isCurrentOffice(office.meta.key)}">
                <v-list-item-action>
                        <v-checkbox @click.stop="toggleOffice(office)" :input-value="office.active"/>
                </v-list-item-action>
                <v-list-item-title>{{office.name}} ({{office.meta.key}})</v-list-item-title>
                <v-list-item-icon>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <v-icon @click.stop="onlyOffice(office)" v-on="on"  color="grey lighten-1">explore</v-icon>
                      </template>
                      <span>View Only {{office.name}}</span>
                    </v-tooltip>
                </v-list-item-icon>                
            </v-list-item>
        </v-list>
    </v-menu>
    </div>
</template>

<script>
import DataHelpers from '../helpers/DataHelpers'
import OrderHelpers from '../helpers/OrderHelpers'
import TeamHelpers from '../helpers/TeamHelpers'
import StringHelpers from '../helpers/StringHelpers'
import Firestore from '../data/Firestore'

export default {
    data() {
        return {
            menuVisible: false,
        }
    },

    components: {
        
    },
    
    props: {
        buttonStyle: String,
        buttonClass: String,
    },

    computed: {
        hasMultipleOffices() {
            return (this.offices.length > 1)
        },

        offices() {
            return this.$store.getters.offices.sort(OrderHelpers.sortByName)
        },

        officesActive() {
            return this.$store.getters.officesActive
        },

        currentOffice() {
            return this.offices.find(o => o.meta.key == DataHelpers.getTenantKey()) || {}
        },

        activeCount() {
            const ctr = this.officesActive.length
            if(ctr < 2)
                return ''
            return ' +' + (ctr - 1).toString()
        },
            debugInfinite() {
                console.log('debugging oc infinite')
                return true
            },

    },

    methods: {
        toggleOffice(office, forceTrue) {
            let newActive = forceTrue || !office.active

            // Write to store then db
            
            this.$store.commit('setOfficeActive', {officeNumber: office.meta.key, value: newActive})
            DataHelpers.getUserRef().child('offices').child(office.meta.key).child('active').set(newActive)

            //write to teams in firestore...
            if(newActive)
                TeamHelpers.activateTeam(StringHelpers.toCamelCase(office.name))
            else
                TeamHelpers.deactivateTeam(StringHelpers.toCamelCase(office.name))
                

            // If I've unchecked a box, then it can't be the current tenant, so set current to the first active one.
            if(!newActive && office.meta.key == DataHelpers.getTenantKey()) {
                if(this.officesActive.length) {
                    this.switchToOffice(this.officesActive[0])
                }
            }

        },

        switchToOffice(office) {
            //timeout gives time for toggle office to complete before switching...
            setTimeout( () => {
                console.log('running switch to office')
                this.toggleOffice(office, true, true)
                DataHelpers.initialiseTenant(office.meta.key)
                TeamHelpers.setPrimaryTeam(StringHelpers.toCamelCase(office.name))
            }, 250)
        },

        onlyOffice(office) {
            this.officesActive.forEach(office => {
                this.toggleOffice(office)
            })
            this.switchToOffice(office)
            this.menuVisible = false
        },

        isCurrentOffice(officeKey) {
            return Boolean(officeKey == DataHelpers.getTenantKey())
        },


    },

    created() {

    }
}
</script>

<style scoped>
    .office-chooser {

    }
    .office-chooser-button {
        color: #333;
        display: flex;
        justify-content: center;
        background-color: rgba(0,0,0,0.05);
    }
</style>




// WEBPACK FOOTER //
// OfficeChooser.vue?3609e8c4